import { render, staticRenderFns } from "./BrandVoiceForm.vue?vue&type=template&id=e832ee40"
import script from "./BrandVoiceForm.vue?vue&type=script&lang=js"
export * from "./BrandVoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports